import React from 'react';
import PropTypes from 'prop-types';
import '../assets/styles.css'

const Card = ({ children }) => {
    return (
        <div className='_kanis_card'>
            {children}
        </div>
    );
}

export default Card;

Card.propTypes = {
    children: PropTypes.node,
};